import { render, staticRenderFns } from "./grayNumber_one.vue?vue&type=template&id=5b4fc34b&scoped=true&"
import script from "./grayNumber_one.vue?vue&type=script&lang=js&"
export * from "./grayNumber_one.vue?vue&type=script&lang=js&"
import style0 from "./grayNumber_one.vue?vue&type=style&index=0&id=5b4fc34b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4fc34b",
  null
  
)

export default component.exports